import Sept2026UpdateImg from '../assets/LayerLibrarySept2026.png';
import type { FeatureAnnouncementContent } from '../types';

export const september2026Update: FeatureAnnouncementContent = {
  announcementTitle: 'CivilGrid Product Update, September 2026',
  announcementSubtitle:
    "Every user used to open the map to the same generic layer set. Now you control exactly what's in the picker.",
  announcementId: 'sept-2026-product-update',
  featureTitle: 'Introducing Layer Library',
  featureDescription: `
    
      Browse CivilGrid's full layer catalog and build the exact set you want in your picker. Add what you need, remove
      what you don't — configure it any time from your <a
        href="/settings/layerLibrary"
      >Layer Library</a>.
    `,
  image: {
    src: Sept2026UpdateImg,
    alt: 'The Layer Library: search sub-layers, set organization defaults, and reset anytime',
  },
  featureItems: [
    {
      title: "Search Finds What's Inside a Layer",
      testId: 'search-inside-layer',
      description: `Search now matches sub-layer names too. Look up "monuments" and you'll get the Survey bucket, even though Monuments is just one of its 7 sub-layers.`,
    },
    {
      title: 'Org Admins Set the Starting Point',
      testId: 'admins-set-starting-point',
      description:
        'Admins can now define a default layer set for the whole org from Org Settings → Layer Library. Every teammate opens the map to the layers that matter for your team.',
    },
    {
      title: 'Reset to Default, Anytime',
      testId: 'reset-to-default',
      description:
        "Changed your mind? Reset Layers puts you right back to your organization's — or CivilGrid's — default set in one click.",
    },
  ],
};
